const Index = () => import("./index.vue");
const SerializedInventory = () => import("./SerializedInventory.vue");

export default [{
  path: "serialized-inventory",
  component: Index,
  children: [{
    path: "",
    name: "serialized-inventory",
    component: SerializedInventory,
  }],
}];
